"use strict";
exports.__esModule = true;
exports.DEFAULTS = exports.REDUCER_ACTIONS = exports.NEW_TASK = exports.META_KEYS = exports.TASKBOX_KEYS = exports.TABS = void 0;
exports.TABS = {
    TASKBOX: 'taskbox',
    BOT_BREAK: 'bot-break',
    AGENT_FEEDBACK: 'agent-feedback',
};
exports.TASKBOX_KEYS = {
    TASK_NAME: 'name',
    USER_SAYS: 'message',
    LOCATION_REQUIRED: 'location_required',
    TASKBOX_SUPPORT: 'is_taskbox_supported',
    TASK_ACTIVE: 'active',
    TASK_IMAGE: 'image_url',
    TASK_RULES: 'rules',
    BUSINESS_TASKS: 'business_tasks',
    BUSINESS_HEADERS: 'business_task_headers',
    BUSINESS_TASK_COMPRESS_MENU: 'business_task_compress_menu',
    BUSINESS_TASK_WELCOME_MESSAGE_DETAILS: 'business_task_welcome_message_details',
};
exports.META_KEYS = {
    LANGUAGE_LIST: 'language_list',
};
exports.NEW_TASK = {
    id: '',
    name: 'New Menu Option',
    message: '',
    relevance: 0,
    short_hand: null,
    is_tasklist_supported: false,
    is_taskbox_supported: false,
    location_required: false,
    active: false,
    image_url: '',
    image_name: '',
    rules: {
        enabled: false,
        show_on_mobile: false,
        clause: 'AND',
        rule_list: [
            {
                variable: 'page_url',
                operator: 'eq',
                value: '',
                meta: {},
            },
        ],
    },
};
// Action types for reducer
var SET_CURRENT_TAB = 'SET_CURRENT_TAB';
var SET_LOADER_ACTIVE = 'SET_LOADER_ACTIVE';
var SET_TRANSFER_MODAL_ACTIVE = 'SET_TRANSFER_MODAL_ACTIVE';
var SET_TRANSFER_TASK_ID = 'SET_TRANSFER_TASK_ID';
var SET_ALL_TASKBOX_DATA = 'SET_ALL_TASKBOX_DATA';
var SET_TASKBOX_DATA = 'SET_TASKBOX_DATA';
var SET_TASK_BOX_EDITED = 'SET_TASK_BOX_EDITED';
var SET_LANGUAGE_CODE = 'SET_LANGUAGE_CODE';
var ADD_NEW_TASK = 'ADD_NEW_TASK';
var SORT_TASK_LIST = 'SORT_TASK_LIST';
var SET_ALL_BOTBREAK_DATA = 'SET_ALL_BOTBREAK_DATA';
var SET_BOTBREAK_TEMPLATE_DATA = 'SET_BOTBREAK_TEMPLATE_DATA';
var SET_BOT_BREAK_EDITED = 'SET_BOT_BREAK_EDITED';
var SET_FEEDBACK_MESSAGES_DATA = 'SET_FEEDBACK_MESSAGES_DATA';
var SET_FEEDBACK_MESSAGES_EDITED = 'SET_FEEDBACK_MESSAGES_EDITED';
var SET_CURRENT_HYBRID_LANGUAGE = 'SET_CURRENT_HYBRID_LANGUAGE';
var SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var SET_TRANSLATE_LOADING = 'SET_TRANSLATE_LOADING';
var SET_DATA_UPDATED_CHANNELS = 'SET_DATA_UPDATED_CHANNELS';
var SET_GPT_UPDATED_CHANNELS = 'SET_GPT_UPDATED_CHANNELS';
var SET_GPT_BASED_BOT_BREAK_CHECK = 'SET_GPT_BASED_BOT_BREAK_CHECK';
var UPDATE_DPSV_CHANNELS = 'UPDATE_DPSV_CHANNELS';
var SET_UPDATED_FEEDBACK_CHANNELS = 'SET_UPDATED_FEEDBACK_CHANNELS';
// Reducer Actions
exports.REDUCER_ACTIONS = {
    SET_CURRENT_TAB: SET_CURRENT_TAB,
    SET_LOADER_ACTIVE: SET_LOADER_ACTIVE,
    SET_TRANSFER_MODAL_ACTIVE: SET_TRANSFER_MODAL_ACTIVE,
    SET_TRANSFER_TASK_ID: SET_TRANSFER_TASK_ID,
    SET_ALL_TASKBOX_DATA: SET_ALL_TASKBOX_DATA,
    SET_TASKBOX_DATA: SET_TASKBOX_DATA,
    SET_TASK_BOX_EDITED: SET_TASK_BOX_EDITED,
    SET_LANGUAGE_CODE: SET_LANGUAGE_CODE,
    ADD_NEW_TASK: ADD_NEW_TASK,
    SORT_TASK_LIST: SORT_TASK_LIST,
    SET_ALL_BOTBREAK_DATA: SET_ALL_BOTBREAK_DATA,
    SET_BOTBREAK_TEMPLATE_DATA: SET_BOTBREAK_TEMPLATE_DATA,
    SET_BOT_BREAK_EDITED: SET_BOT_BREAK_EDITED,
    SET_FEEDBACK_MESSAGES_DATA: SET_FEEDBACK_MESSAGES_DATA,
    SET_FEEDBACK_MESSAGES_EDITED: SET_FEEDBACK_MESSAGES_EDITED,
    SET_CURRENT_HYBRID_LANGUAGE: SET_CURRENT_HYBRID_LANGUAGE,
    SET_CURRENT_CHANNEL: SET_CURRENT_CHANNEL,
    SET_TRANSLATE_LOADING: SET_TRANSLATE_LOADING,
    SET_DATA_UPDATED_CHANNELS: SET_DATA_UPDATED_CHANNELS,
    SET_GPT_UPDATED_CHANNELS: SET_GPT_UPDATED_CHANNELS,
    SET_GPT_BASED_BOT_BREAK_CHECK: SET_GPT_BASED_BOT_BREAK_CHECK,
    UPDATE_DPSV_CHANNELS: UPDATE_DPSV_CHANNELS,
    SET_UPDATED_FEEDBACK_CHANNELS: SET_UPDATED_FEEDBACK_CHANNELS,
};
exports.DEFAULTS = {
    LANGUAGE: 'en',
    CHANNEL_ID: '5',
    CHANNEL_NAME: 'WebSDK',
};
